<template>
  <div>
    <v-snackbar v-model="success" color="success"
      >{{ successMessage
      }}<template v-slot:action="{ attrs }">
        <v-divider vertical></v-divider>
        <v-btn icon @click="initSuccess">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </template></v-snackbar
    >
    <v-snackbar v-model="error" color="error">{{ errorMessage }}</v-snackbar>
    <v-dialog v-model="showDialog" scrollable max-width="350px">
      <v-card>
        <v-card-title>Lista de Borradores</v-card-title>
        <v-divider></v-divider>
        <v-card-text style="height: 350px" class="px-2">
          <template v-if="draftList.length">
            <v-list dense>
              <template v-for="(draft, index) in draftList">
                <v-list-item :key="index" two-line>
                  <v-list-item-content
                    v-ripple="{ center: true }"
                    style="cursor: pointer"
                    @click="selectDraft(index)"
                  >
                    <v-list-item-title
                      v-text="draft.nombrePuesto"
                    ></v-list-item-title>
                    <v-list-item-subtitle class="text-caption"
                      >Guardado
                      {{
                        formatDate(draft.fechaGuardado)
                      }}</v-list-item-subtitle
                    >
                  </v-list-item-content>
                  <v-list-item-action>
                    <v-btn icon @click="removeSingleDraft(index)"
                      ><v-icon color="error" class="my-auto"
                        >mdi-trash-can</v-icon
                      ></v-btn
                    >
                  </v-list-item-action>
                </v-list-item>
              </template>
            </v-list>
          </template>
          <v-container
            v-else
            class="d-flex justify-center align-center align-self-center"
            style="height: 85%"
          >
            <div class="text-disabled">No tienes borradores guardados</div>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from "vuex";
import { StorageService } from "@/services/storage.service";

export default {
  props: {
    success: {
      type: Boolean,
      default: false
    },
    error: {
      type: Boolean,
      default: false
    },
    successMessage: {
      type: String,
      default: "Realizado"
    },
    errorMessage: {
      type: String,
      default: "Error"
    },
    timeout: {
      type: Number,
      default: 3000
    }
  },

  data() {
    return {
      draftList: []
    };
  },

  computed: {
    showDialog: {
      get() {
        return this.getDraftsPropuestaDialog;
      },

      set(value) {
        this.setDraftsPropuestaDialog(value);
      }
    },
    ...mapGetters("company", ["getDraftsPropuestaDialog"])
  },

  methods: {
    initSuccess() {
      this.$emit("update:success", false);
      //this.$emit("update:successMessage", "Realizado");
    },

    initError() {
      this.$emit("update:error", false);
      //this.$emit("update:errorMessage", "Error");
    },

    fetchDrafts() {
      let drafts = JSON.parse(StorageService.getDrafts());
      this.draftList = drafts ? drafts : [];
    },

    selectDraft(index) {
      this.$emit("load-draft", this.draftList[index]);
      this.setDraftsPropuestaDialog(false);
    },

    removeSingleDraft(index) {
      let drafts = JSON.parse(StorageService.getDrafts());
      drafts.splice(index, 1);
      StorageService.saveDraft(drafts);
      this.fetchDrafts();
    },

    ...mapMutations("company", ["setDraftsPropuestaDialog"])
  },

  watch: {
    success(newValue, oldValue) {
      if (newValue && !oldValue) {
        let vm = this;
        setTimeout(function () {
          vm.initSuccess();
        }, vm.timeout);
      }
    },

    error(newValue, oldValue) {
      if (newValue && !oldValue) {
        let vm = this;
        setTimeout(function () {
          vm.initError();
        }, vm.timeout);
      }
    },

    showDialog(newValue, oldValue) {
      if (!oldValue && newValue) {
        this.fetchDrafts();
      }
    }
  },

  mounted() {
    this.fetchDrafts();
  }
};
</script>

<style>
</style>
